import { render, staticRenderFns } from "./PlayerPage.vue?vue&type=template&id=ea55c9fc"
import script from "./PlayerPage.vue?vue&type=script&lang=js"
export * from "./PlayerPage.vue?vue&type=script&lang=js"
import style0 from "./PlayerPage.vue?vue&type=style&index=0&id=ea55c9fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports